// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"693":"62ba908c","977":"16141e6f"}[chunkId] + ".chunk.js";
};